import React from 'react'
import { useState } from 'react'
import {Modal, Button} from 'react-bootstrap'
import PropTypes from 'prop-types'
import {itemType, s3fileType} from '../types'
import GroupFileListTable from './GroupFileListTable'
import { get } from 'lodash'

export default function S3FileuploadModal(props) {
  const [showDownloadLinks, setShowDownloadLinks] = useState(true)
  const [disableDownload, setDisableDownload] = useState(true)
  const [validDownloadUrls, setValidDownloadUrls] = useState([])

  const copyDownloadLinks = () =>{
    function textToClipboard (text) {
      var temp = document.createElement('textarea')
      document.body.appendChild(temp)
      temp.value = text
      temp.select()
      document.execCommand('copy')
      document.body.removeChild(temp)
    }
    const text = validDownloadUrls.map(x=>x.downloadUri).join('\n')
    textToClipboard(text)
  }
  const backDownloadLinks = () =>{
    setShowDownloadLinks(true)
  }
  const handleDownloadLinks = () =>{
    setShowDownloadLinks(false)
  }

  return (
    <div>
      <Modal {...props} size='lg' backdrop="static" scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>{showDownloadLinks?'Please select the files you wish to download':
            'The following are the download links for the files you selected'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <GroupFileListTable
            s3FileLists={get(props.item, 'fileConnection.files', {}) ||[]}
            show={showDownloadLinks}
            setDisableDownload ={setDisableDownload}
            itemId={props.itemId}
            setValidDownloadUrls = {setValidDownloadUrls}
          />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{
            props.onHide(false)
            setShowDownloadLinks(true)
          }}>
                Close
          </Button>
          {showDownloadLinks?<Button variant="secondary" disabled={disableDownload} onClick={handleDownloadLinks}>
                Download Links
          </Button>:<><Button data='othervalue' variant="primary" disabled={disableDownload} onClick={backDownloadLinks}>
                Back
          </Button>
          <Button variant="success" disabled={disableDownload} onClick={copyDownloadLinks}>
                Copy to Clipboard
          </Button></>}
        </Modal.Footer>
      </Modal>
    </div>
  )
}

S3FileuploadModal.propTypes = {
  item: itemType,
  onHide: PropTypes.func,
  itemId: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  s3filelist: PropTypes.arrayOf(s3fileType),
  filepath: PropTypes.string
}
